import { useState } from "react";
import { UIButton, UIGrid, UITypography } from "../../_app/components";
import SwitchAccountsDialog from "./SwitchAccountsDialog";

function SwitchAccounts() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const goToSwitchAccounts = () => {
    setIsDialogOpen(true);
  };

  return (
    <UIGrid container direction="column" justifyContent="center" alignItems="center" height={580}>
      <UITypography variant="h2" gutterBottom>
        Please select an account
      </UITypography>

      <UIButton variant="contained" color="primary" onClick={goToSwitchAccounts} data-cy="select_account_button">
        Open Account Select
      </UIButton>
      <SwitchAccountsDialog open={isDialogOpen} setOpen={setIsDialogOpen} />
    </UIGrid>
  );
}

export default SwitchAccounts;
